import Cookies from "js-cookie";

// Never return/log Axios errors: their config can contain passwords or tokens.
export function administrativeError(error, fallback) {
    const status = error.response?.status;
    if (status === 401) Cookies.remove("Bearer");
    return {
        success: false,
        status,
        data: error.response?.data,
        message: status === 401
            ? "Your session has expired. Please sign in again."
            : status === 403
            ? "This operation is not authorized or is temporarily restricted. Please contact your administrator."
            : status === 404
            ? "The requested account or Team is unavailable or inaccessible."
            : status === 409
            ? "The data has changed or reassignment could not be completed. Review your selections and reload the preview before trying again."
            : status
            ? fallback
            : "The server could not be reached. The outcome is unknown; check the current state before trying again.",
    };
}
